const contractingCorporationProfileEn = {
  title: "Contracting Corporation Profile",
  tabs: {
    corporateOverview: "Corporate Overview",
    registration: "Registration",
    boardMember: "Board Members",
    history: "History",
    groupCompanies: "Group Companies",
    shareholders: "Shareholders",
    contactPoints: "Contact Points",
  },
  boardMember: {
    searchPlaceholder: "Search by name or email...",
    noResults: "No board members found",
  },
  error: {
    loadingFailed: "Failed to load data",
    unknownError: "An unknown error occurred",
  },
  validation: {
    required: "{{field}} is required",
  },
};

export default contractingCorporationProfileEn;
